"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckRailDrybox = function SvgIconTruckRailDrybox(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck rail drybox icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Rail Drybox Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.97 7.64h-2.01V25h2.01V7.64zm8.04-.03H19V25h2.01V7.61zM37.09 8h-2.01v17h2.01V8zm-8.04-.39h-2.01V25h2.01V7.61zM43.93 4v25h-40V4h40zm.57 27c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-41c-.83 0-1.5-.67-1.5-1.5S2.67 31 3.5 31h41zM12 40a4 4 0 11-8 0 4 4 0 018 0zm0 0a4 4 0 118 0 4 4 0 01-8 0zm24 0a4 4 0 11-8 0 4 4 0 018 0zm0 0a4 4 0 118 0 4 4 0 01-8 0z"
  }));
};

var _default = SvgIconTruckRailDrybox;
exports.default = _default;